import { useEffect, useState } from "react";
import api from "../../../services/api/index";

const replaceBigIntProp = data => {
  let replacedData;
  if (
    data === null ||
    typeof data === "boolean" ||
    typeof data === "number" ||
    typeof data === "string"
  ) {
    replacedData = data;
  } else if (Array.isArray(data)) {
    replacedData = data.map(v => replaceBigIntProp(v));
  } else {
    replacedData = Object.entries(data).reduce((result, [key, value]) => {
      if (key.endsWith("_(rl_big_limit)")) {
        result[key.replace("_(rl_big_limit)", "")] = BigInt(value);
      } else if (
        value === null ||
        typeof value === "boolean" ||
        typeof value === "number" ||
        typeof value === "string"
      ) {
        result[key] = value;
      } else {
        result[key] = replaceBigIntProp(value);
      }
      return result;
    }, {});
  }
  return replacedData;
};

const useTiCoreApi = (hashValue, path, filterData, pageData, orderData) => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isActive = true;
    setLoading(true);
    let fields;
    if (Array.isArray(path)) {
      fields = path;
    } else {
      const params = {
        ...(Object.keys(pageData || {}).length > 0 && { paging: pageData }),
        ...(Object.keys(filterData || {}).length > 0 && { filter: filterData }),
        ...(Object.keys(orderData || {}).length > 0 && { order: orderData })
      };
      fields = `${path}${
        Object.keys(params).length > 0 ? JSON.stringify([params]) : ""
      }`;
    }

    api
      .tcAnalysisMetadata(hashValue, fields)
      .then(res => isActive && setResponse(replaceBigIntProp(res.data)))
      .catch(err => isActive && setError(err))
      .finally(() => isActive && setLoading(false));

    return () => {
      isActive = false;
    };
  }, [pageData, filterData, orderData]);

  // custom hook returns value
  return [response, error, loading];
};

export default useTiCoreApi;
